import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
// eslint-disable-next-line import/no-unused-modules
export var SvgRoot = styled.svg(function (_a) {
    var height = _a.height, size = _a.theme.size, width = _a.width;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    --height: ", ";\n    --width: ", ";\n    flex-shrink: 0;\n    height: var(--height);\n    user-select: none;\n    width: var(--width);\n\n    &:not(:root) {\n      overflow: hidden;\n    }\n\n    &[fill='none'] {\n      fill: none;\n    }\n  "], ["\n    --height: ", ";\n    --width: ", ";\n    flex-shrink: 0;\n    height: var(--height);\n    user-select: none;\n    width: var(--width);\n\n    &:not(:root) {\n      overflow: hidden;\n    }\n\n    &[fill='none'] {\n      fill: none;\n    }\n  "])), function () {
        if (typeof height === 'undefined') {
            return 'auto';
        }
        if (typeof size[height] === 'string') {
            return size[height];
        }
        return height;
    }, function () {
        if (typeof width === 'undefined') {
            return 'auto';
        }
        if (typeof size[width] === 'string') {
            return size[width];
        }
        return width;
    });
});
var templateObject_1;
//# sourceMappingURL=Svg.styles.js.map